/**
 * 预加载方法
 */
var PRELOADER = {
    /**
     * 预加载基础函数
     * @param {图片列表} images 
     * @param {成功回调} sucCb 
     * @param {失败回调} failCb 
     */
    loadImageList(images, sucCb, failCb) {
        var count = 0;
        for(var img of images) {
            console.log('img---------', img);
            var image = new Image();
            image.src = img;
            image.onload = () => {
                count++;
                if(count == images.length) {
                    // 图片加载完成回调
                    if(sucCb && typeof(sucCb) == 'function') {
                        sucCb(images);
                    }
                }
            };
            image.onerror = () => {
                // 图片加载失败回调
                if(failCb && typeof(failCb) == 'function') {
                    failCb();
                }
            }
        }
    },
    /**
     * 预加载首页图片列表
     * @param {成功回调} sucCb 
     * @param {失败回调} failCb 
     */
    loadIndexImageList(sucCb, failCb) {
        var images = [
            'http://m1.2048.net/duoniu/images/common/music-on.png',
            'http://m1.2048.net/duoniu/images/common/music-off.png',
            'http://m1.2048.net/duoniu/images_thj/discount-bg.png',
            'http://m1.2048.net/duoniu/images_thj/discount-btn.png',
            'http://m1.2048.net/duoniu/images/index/index-title.png',
            'http://m1.2048.net/duoniu/images/index/index-button.png',
            'http://m1.2048.net/duoniu/images/index/index-bg.png',
            'http://m1.2048.net/duoniu/images_thj/index/index-bg.png',
            'http://m1.2048.net/duoniu/images_thj/index/index-c-bg.png',
            'http://m1.2048.net/duoniu/images_thj/index/index-t-bg.png',
            'http://m1.2048.net/duoniu/images_thj/index/index-cow.png',
            'http://m1.2048.net/duoniu/images_thj/index/index-title.png',
            'http://m1.2048.net/duoniu/images_thj/index/index-c-title.png',
            'http://m1.2048.net/duoniu/images_thj/index/index-bar.png',
        ];
        PRELOADER.loadImageList(images, sucCb, failCb);
    },
    /**
     * 预加载生成页图片列表
     * @param {成功回调} sucCb 
     * @param {失败回调} failCb 
     */
    loadGenerateImageList() {
        var images = [
            'http://m1.2048.net/duoniu/images/common/music-on.png',
            'http://m1.2048.net/duoniu/images/common/music-off.png',
            'http://m1.2048.net/duoniu/images/logo.png',
            'http://m1.2048.net/duoniu/images_thj/report/star-bg.png',
            'http://m1.2048.net/duoniu/images_thj/report/star-bg2.png',
            'http://m1.2048.net/ani/earth-min.png',
            'http://m1.2048.net/ani/sun-min.png',
            'http://m1.2048.net/ani/man-g.png',
            'http://m1.2048.net/ani/woman-g.png',
        ];
        PRELOADER.loadImageList(images, sucCb, failCb);
    },
    /**
     * 预加载报告页图片列表
     * @param {成功回调} sucCb 
     * @param {失败回调} failCb 
     */
    loadReportImageList(sucCb, failCb) {
        var images = [
            'http://m1.2048.net/duoniu/images/common/music-on.png',
            'http://m1.2048.net/duoniu/images/common/music-off.png',
            'http://m1.2048.net/duoniu/images_thj/discount-bg.png',
            'http://m1.2048.net/duoniu/images_thj/discount-btn.png',
            'http://m1.2048.net/duoniu/images_rabbit/share/share-bg-aiguo.png',
            'http://m1.2048.net/duoniu/images_rabbit/share/share-bg-fuqiang.png',
            'http://m1.2048.net/duoniu/images_rabbit/share/share-bg-hexie.png',
            'http://m1.2048.net/duoniu/images_rabbit/share/share-bg-jingye.png',
            'http://m1.2048.net/duoniu/images_rabbit/share/share-bg-youshan.png',
            'http://m1.2048.net/duoniu/images_thj/report/report-btn.png',
            'http://m1.2048.net/duoniu/images_thj/report/report-btn2.png',
            'http://m1.2048.net/duoniu/images_thj/report/report-bg.png',
            'http://m1.2048.net/duoniu/images/report/report-back.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-t-aiguo.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-t-fuqiang.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-t-hexie.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-t-jingye.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-t-youshan.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-aiguo.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-fuqiang.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-hexie.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-jingye.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-youshan.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-bg-aiguo.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-bg-fuqiang.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-bg-hexie.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-bg-jingye.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-bg-youshan.png',
            'http://m1.2048.net/duoniu/images_thj/report/report-light.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-sbg-aiguo.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-sbg-fuqiang.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-sbg-hexie.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-sbg-jingye.png',
            'http://m1.2048.net/duoniu/images_rabbit/cow/cow-sbg-youshan.png',
            'http://m1.2048.net/duoniu/images/common/num-0.png',
            'http://m1.2048.net/duoniu/images/common/num-1.png',
            'http://m1.2048.net/duoniu/images/common/num-2.png',
            'http://m1.2048.net/duoniu/images/common/num-3.png',
            'http://m1.2048.net/duoniu/images/common/num-4.png',
            'http://m1.2048.net/duoniu/images/common/num-5.png',
            'http://m1.2048.net/duoniu/images/common/num-6.png',
            'http://m1.2048.net/duoniu/images/common/num-7.png',
            'http://m1.2048.net/duoniu/images/common/num-8.png',
            'http://m1.2048.net/duoniu/images/common/num-9.png',
            'http://m1.2048.net/duoniu/images/share/share-cbg.png',
            'http://m1.2048.net/duoniu/images_thj/report/code1.png',
            'http://m1.2048.net/duoniu/images_thj/report/code2.png',
            'http://m1.2048.net/duoniu/images_thj/report/code3.png',
            'http://m1.2048.net/duoniu/images_thj/report/report-share.png',
            'http://m1.2048.net/duoniu/images_thj/report/report-share-save.png',
            'http://m1.2048.net/d.png',
        ];
        PRELOADER.loadImageList(images, sucCb, failCb);
    },
    /**
     * 预加载音频文件
     */
    loadReportAudio(sucCb) {
        var audio = new Audio();
        audio.src = 'http://m1.2048.net/duoniu/audio/audio-index.mp3';
        audio.load();
        // console.log('loadReportAudio-----', audio)
        setTimeout(() => {
            audio.src = 'http://m1.2048.net/duoniu/audio/audio-generate.mp3';
            audio.load();
        }, 100);
        setTimeout(() => {
            audio.src = 'http://m1.2048.net/duoniu/audio/audio-report.mp3';
            audio.load();
        }, 500);
        setTimeout(() => {
            if(sucCb && typeof(sucCb) == 'function') {
                sucCb();
            }
        }, 1000);
    }
}

export {
    PRELOADER
}